import { apiRequest } from "./common";

const createReflection = async (data) => {
    const response = await apiRequest('post', '/project-reflection', data);
    return response.data;
};

const updateReflecation = async (id, data) => {
    const response = await apiRequest('put', `/project-reflection/${id}`, data);
    return response.data;
};

const deleteReflection = async (id) => {
    const response = await apiRequest('delete', `/project-reflection/${id}`);
    return response.data;
};

const getReflection = async (projectId) => {
    const response = await apiRequest('get', `/project-reflection/project/${projectId}`);
    return response.data;
};

export {
    createReflection,
    updateReflecation,
    deleteReflection,
    getReflection
}